import { Component } from '@angular/core';

@Component({
    selector: 'app-pks-bursa-thank-you',
    templateUrl: './pks-bursa-thank-you.component.html',
    standalone: false
})
export class PksBursaThankYouComponent {}
